import React from "react"
import {
	WithI18nProps,
	withI18n,
} from "@7egend/web-core/lib/components/withI18n"
import {
	BlockComponentProps,
	BlocksEditor,
	Wrapper,
} from "@7egend/dxp-web-core/lib/components"
import { Block, Text } from "@7egend/web-core-cms/lib/dlos"
import { CUSTOM_BLOCKS } from "@/configs/blocks"
import { blockTypes } from "@7egend/dxp-web-core/lib/components/BlockDrawer/BlockType/config"
import { Medium } from "@7egend/dxp-web-core/lib/dlos/cms/media"
import { TestimoniesContainer } from "@/dlos/reservations"
import { useConfigFootlabModule } from "@/hooks/useConfig"
import { merge } from "@7egend/web-core/lib/utils/merge"

const Structure = {
	id: undefined,
	type: blockTypes.container.type,
	content: {
		id: undefined,
		name: "Container",
		style: "1001",
		blocks: [],
	},
} as unknown as Partial<
	Pick<Block<Pick<TestimoniesContainer, "blocks">>, "type" | "content">
>

const ComponentInner: React.FC<
	BlockComponentProps<TestimoniesContainer> & WithI18nProps
> = ({ data, updateData, t, locale }) => {
	const config = useConfigFootlabModule()

	const blocksConfig = (
		config.blocks?.["footlab.testimonies"]?.[0]?.Structure as Block<
			Partial<TestimoniesContainer>
		>
	).content.blocks

	return (
		<Wrapper>
			<BlocksEditor
				sortable={false}
				allowAdd={false}
				allowRemove={false}
				labels={[
					t("testimonies.blockLabelText"),
					t("testimonies.blockLabelAuthor"),
					t("testimonies.blockLabelMedia"),
				]}
				types={[
					CUSTOM_BLOCKS.overrides.smallText,
					CUSTOM_BLOCKS.overrides.media,
				]}
				blocks={merge([], blocksConfig, data.content?.blocks) || []}
				onChange={(blocks: Block[]) =>
					updateData({
						...data,
						content: {
							...data.content,
							blocks: [
								(blocks as Block<Text>[])[0],
								(blocks as Block<Text>[])[1],
								(blocks as Block<Medium>[])[2],
							],
						},
					})
				}
				locale={locale}
			/>
		</Wrapper>
	)
}

const Component = withI18n()(ComponentInner)

const Button = {
	icon: "comment",
	name: "Testimonials",
}

export const Testimonies = {
	key: "5_1003",
	Structure: Structure as any as Block<TestimoniesContainer>,
	Component,
	Button,
}
